// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnknownUser__container-bd4478 {
  padding: 0 16px;
  background-color: var(--base-0);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border-bottom: 1px solid var(--base-20);
}

.UnknownUser__username-ece2a4 {
  color: var(--base-80);
}

.UnknownUser__actions-a68fe5 {
  display: flex;
  align-items: center;
}

.UnknownUser__action-d701e5 {
  margin-inline-end: 16px;
}

.UnknownUser__close-b3d32f svg {
  width: 16px;
  height: 16px;
  color: var(--base-60);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/UnknownUser/UnknownUser.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,uCAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  padding: 0 16px;\n  background-color: var(--base-0);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.username {\n  color: var(--base-80);\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n}\n\n.action {\n  margin-inline-end: 16px;\n}\n\n.close svg {\n  width: 16px;\n  height: 16px;\n  color: var(--base-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UnknownUser__container-bd4478`,
	"username": `UnknownUser__username-ece2a4`,
	"actions": `UnknownUser__actions-a68fe5`,
	"action": `UnknownUser__action-d701e5`,
	"close": `UnknownUser__close-b3d32f`
};
module.exports = ___CSS_LOADER_EXPORT___;
